import { CreditCard } from "@/icons/CreditCard.tsx";
import useUserStore from "@/store/user.store.ts";
import { Alert, Button, Text } from "@mantine/core";
import { Link } from "react-router";

export function SubscriptionCard() {
  const { hasActiveSubscription } = useUserStore();
  const hasActive = hasActiveSubscription();

  if (hasActive) {
    return null;
  }

  return (
    <Alert
      title="Subscription status"
      bd="1px dashed yellow.9"
      variant="light"
      color="yellow"
      icon={<CreditCard size={40} />}
    >
      <div className="flex flex-col gap-4">
        <Text>
          You have no active subscriptions. Your photos will be deleted after 10
          days.
        </Text>

        <Button
          component={Link}
          to="/billing"
          variant="outline"
          color="yellow"
          size="sm"
        >
          Upgrade
        </Button>
      </div>
    </Alert>
  );
}
